import { render, staticRenderFns } from "./PanelEdit.vue?vue&type=template&id=65046e60&scoped=true&"
import script from "./PanelEdit.vue?vue&type=script&lang=js&"
export * from "./PanelEdit.vue?vue&type=script&lang=js&"
import style0 from "./PanelEdit.vue?vue&type=style&index=0&id=65046e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65046e60",
  null
  
)

export default component.exports